/**
 * Formateo de fechas para la UI. Todo lo que viene del backend es ISO en UTC;
 * acá se muestra siempre en la hora local del navegador (que para el equipo es
 * Argentina), porque el operador razona en su propio huso.
 */

/** dd/mm/aaaa hh:mm, o '—' si no hay fecha o no parsea. */
export function fechaHora(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${d.toLocaleDateString('es-AR')} ${d.toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}

/**
 * d/m corto (sin año), o '—' si no hay fecha o no parsea. Para columnas
 * angostas — pensado para fechas-calendario puras (vigencias), no timestamps:
 * usa los componentes UTC del ISO tal cual, sin reinterpretar en hora local.
 * Una vigencia como "2026-06-01T00:00:00.000Z" es el 1/6 para todos, más allá
 * del huso del navegador — convertir a local (UTC-3 en Argentina) la corre al
 * 31/5, que es el bug que esto evita.
 */
export function fechaCorta(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${d.getUTCDate()}/${d.getUTCMonth() + 1}`;
}
